import { Badge, type BadgeProps } from '@chakra-ui/react'

type OptionalFieldBadgeProps = {
  size?: BadgeProps['size']
}

export function OptionalFieldBadge({ size = 'sm' }: OptionalFieldBadgeProps) {
  return (
    <Badge variant="subtle" colorPalette="gray" size={size}>
      optional
    </Badge>
  )
}
